{
  "name": "frontend-kirmes",
  "version": "22.2.0-RC.1",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "lint": "ng lint",
    "bundle-report": "ng build --stats-json"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/cdk": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/material": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/platform-browser-dynamic": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@auth0/auth0-angular": "^2.13.0",
    "@codewithdan/observable-store": "^2.2.15",
    "@codewithdan/observable-store-extensions": "^2.2.9",
    "@geoman-io/leaflet-geoman-free": "^2.20.0",
    "@mercatus/anmeldeformular": "^0.4.4",
    "@microsoft/signalr": "^6.0.25",
    "@primeng/themes": "^21.0.2",
    "@primeuix/themes": "^2.0.2",
    "@sentry/browser": "^10.32.1",
    "@types/leaflet": "^1.9.21",
    "bootstrap": "^5.3.8",
    "core-js": "^3.47.0",
    "file-saver": "^2.0.5",
    "font-awesome": "^4.7.0",
    "leaflet": "^1.9.4",
    "ngx-wallaby-jest": "0.0.2",
    "primeicons": "^7.0.0",
    "primeng": "^21.0.2",
    "rxjs": "^7.8.1",
    "ts-enum-util": "^4.1.0",
    "ts-md5": "^2.0.1",
    "tslib": "^2.0.0",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.2.1",
    "@angular-eslint/builder": "^22.5.0",
    "@angular-eslint/eslint-plugin": "^22.5.0",
    "@angular-eslint/eslint-plugin-template": "^22.5.0",
    "@angular-eslint/schematics": "^22.5.0",
    "@angular-eslint/template-parser": "^22.5.0",
    "@angular/cli": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "@angular/language-service": "^22.2.1",
    "@types/node": "^25.0.3",
    "@typescript-eslint/eslint-plugin": "^8.71.1",
    "@typescript-eslint/parser": "^8.71.1",
    "eslint": "^9.39.2",
    "ts-node": "^10.9.2",
    "typescript": "~6.0.3"
  },
  "overrides": {
    "primeng": {
      "@angular/cdk": "$@angular/cdk",
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/forms": "$@angular/forms",
      "@angular/platform-browser": "$@angular/platform-browser",
      "@angular/router": "$@angular/router"
    }
  }
}
